import React from "react";
import Icon1 from "../../assets/Icon1.webp";
import Icon2 from "../../assets/Service-4.webp";
import Icon4 from "../../assets/Service-6.webp";
import Icon11 from "../../assets/Service-1.webp";
import Icon12 from "../../assets/Service-2.webp";
import Icon13 from "../../assets/Service-3.webp";
import Icon15 from "../../assets/Service-7.webp";
import Icon17 from "../../assets/Service-9.webp";
import Icon18 from "../../assets/Service-10.webp";
import Icon20 from "../../assets/Service-12.webp";
import Icon10 from "../../assets/Service-13.webp";
import "./main.css"; // Import your CSS file

function Services() {
  return (
    <React.Fragment>
      <section className="servicess services-container">
        <div className="container-fluid">
          <div className="mobaile-view-services">
            <h1>From Our Basket</h1>
            <h2>Services</h2>
          </div>

          <p>
            With a unique blend of experience and capabilities, we confidently
            offer a wide range of services to our valued customers. The
            Organization has been catering to its customer’s requirements and
            has won several accolades for its service.
          </p>
          <div className="row mt-5">
            <div className="col-lg-3 col-md-6 col-sm-12 mb-3">
              <div className="card">
                <div className="card-body">
                  <div className="servicess-card">
                    <img src={Icon1} className="img-fluid" alt="Ideas-img" />
                    <h3>EPC Contracts (Electrical)</h3>
                  </div>
                  <a href="/EpcContacts"  aria-label="View EPC Electrical Contract services">
                    <div className="hover-service-card">
                      <p className="hover-p">
                        Switchyard upto 400KV <br /> Transmission Line 220KV{" "}
                        <br /> Co-Generation Projects <br /> Boilers
                        <br />
                        <span>
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            aria-hidden="true"
                            focusable="false"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M4.07317 1H15M15 1L1 15M15 1V11.9268"
                              stroke="#FBFBFB"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </span>
                      </p>
                    </div>
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-12 mb-3">
              <div className="card">
                <div className="card-body">
                  <div className="servicess-card">
                    <img src={Icon4} className="img-fluid" alt="Ideas-img" />
                    <h3>Erection, Testing & Commissioning</h3>
                  </div>
                  {/* <a> */}
                    <div className="hover-service-card">
                      <p className="hover-p">
                        Cement Plants <br /> Power Plants <br /> Sugar Plants
                        <br /> Distillery <br /> Steel Plants
                        <span>
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            aria-hidden="true"
                            focusable="false"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M4.07317 1H15M15 1L1 15M15 1V11.9268"
                              stroke="#FBFBFB"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </span>
                      </p>
                    </div>
                  {/* </a> */}
                </div>
              </div>
            </div>
            {/* <div className="col-lg-3 col-md-6 col-sm-12 mb-3">
              <div className="card">
                <div className="card-body">
                  <div className="servicess-card">
                    <img src={Icon3} className="img-fluid" alt="Ideas-img" />
                    <h3>Panel Manufacturing</h3>
                  </div>
                  <a href="/Panel">
                    <div className="hover-service-card">
                      <p className="hover-p">
                        PCC Panels <br /> MCC Panels <br /> APFC Panels <br />{" "}
                        Capacitor Panels <br /> VFD Panels
                        <span>
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M4.07317 1H15M15 1L1 15M15 1V11.9268"
                              stroke="#FBFBFB"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </span>
                      </p>
                    </div>
                  </a>
                </div>
              </div>
            </div> */}
            <div className="col-lg-3 col-md-6 col-sm-12 mb-3">
              <div className="card">
                <div className="card-body">
                  <div className="servicess-card">
                    <img src={Icon2} className="img-fluid" alt="Ideas-img" />
                    <h3>Engineering Services</h3>
                  </div>
                  {/* <a> */}
                    <div className="hover-service-card">
                      <p className="hover-p">
                        Preparation of Electrical Drawings (SLDs and Layouts) <br />
                        Estimation of Engineering Quantities
                        <span>
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            aria-hidden="true"
                            focusable="false"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M4.07317 1H15M15 1L1 15M15 1V11.9268"
                              stroke="#FBFBFB"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </span>
                      </p>
                    </div>
                  {/* </a> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="Service2">
        <div className="container-fluid">
          <div className="mobaile-view-services2">
            <h1>Experience And Capabilities</h1>
            <h2>What Sets Us Apart</h2>
          </div>
          {/* <p className="Sparagraph">
            With a unique blend of experience and capabilities, we confidently
            offer a wide range of services to our valued customers. The
            Organization has been catering to its customer’s requirements and
            has won several accolades for its service.
          </p> */}
          <div className="row">
            <div className="col-lg-3 col-md-6 col-sm-12 mb-4">
              <div className="card">
                <div className="card-body">
                  <div className="Scard-text">
                    <div className="iconS2">
                      <img src={Icon13} alt="Ideas-img" />
                    </div>
                    <div className="heading2">
                      <h3>Experience</h3>
                    </div>
                  </div>
                  <div className="parS">
                    <p>
                      We bring 2 decades of experience to the table, ensuring
                      you are in safe hands.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-12 mb-4">
              <div className="card">
                <div className="card-body">
                  <div className="Scard-text">
                    <div className="iconS2">
                      <img src={Icon12} alt="Ideas-img" />
                    </div>
                    <div className="heading2">
                      <h3>Qualified Team</h3>
                    </div>
                  </div>
                  <div className="parS">
                    <p>
                      Highly qualified Engineers, skilled and unskilled laborers
                      trained to handle a wide range of electrical tasks safely
                      and efficiently.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-12 mb-4">
              <div className="card">
                <div className="card-body">
                  <div className="Scard-text">
                    <div className="iconS2">
                      <img src={Icon11} alt="Ideas-img" />
                    </div>
                    <div className="heading2">
                      <h3>Safety Focus</h3>
                    </div>
                  </div>
                  <div className="parS">
                    <p>
                      Safety is our culture. We adhere to all safety regulations
                      and standards to minimize risks and ensure a secure
                      working environment.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-12 mb-4">
              <div className="card">
                <div className="card-body">
                  <div className="Scard-text">
                    <div className="iconS2">
                      <img src={Icon18} alt="Ideas-img" />
                    </div>
                    <div className="heading2">
                      <h3>Quality Workmanship</h3>
                    </div>
                  </div>
                  <div className="parS">
                    <p>
                      We proudly deliver high-quality workmanship, using the
                      best materials and techniques to ensure long-lasting
                      results.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-12 mb-4">
              <div className="card">
                <div className="card-body">
                  <div className="Scard-text">
                    <div className="iconS2">
                      <img src={Icon10} alt="Ideas-img" />
                    </div>
                    <div className="heading2">
                      <h3>Customer Satisfaction</h3>
                    </div>
                  </div>
                  <div className="parS">
                    <p>
                      Customer satisfaction is our ultimate goal. Targeting to
                      exceed your expectations and build long-term relationships
                      based on trust and reliability.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-12 mb-4">
              <div className="card">
                <div className="card-body">
                  <div className="Scard-text">
                    <div className="iconS2">
                      <img src={Icon15} alt="Ideas-img" />
                    </div>
                    <div className="heading2">
                      <h3>Versatility</h3>
                    </div>
                  </div>
                  <div className="parS">
                    <p>
                      Irrespective of industry or sector we have the expreance
                      and versatility to handle various electrical projects
                      effectively.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-12 mb-4">
              <div className="card">
                <div className="card-body">
                  <div className="Scard-text">
                    <div className="iconS2">
                      <img src={Icon20} alt="Ideas-img" />
                    </div>
                    <div className="heading2">
                      <h3>Reputation</h3>
                    </div>
                  </div>
                  <div className="parS">
                    <p>
                      Our track record speaks everything. We have a reputation
                      for delivering exceptional results and customer
                      satisfaction, backed up by testimonials and referrals from
                      past clients. The repetitive orders from clients tell the
                      entire story.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-12 mb-4">
              <div className="card">
                <div className="card-body">
                  <div className="Scard-text">
                    <div className="iconS2">
                      <img src={Icon17} alt="Ideas-img" />
                    </div>
                    <div className="heading2">
                      <h3>Timely Completion</h3>
                    </div>
                  </div>
                  <div className="parS">
                    <p>
                      We understand the importance of deadlines and strive to
                      complete projects on time and within budget, without
                      compromising on quality.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </React.Fragment>
  );
}

export default Services;
